import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';
import { transform, defaultConverters } from './lib';
import { StyledRichText } from './RichText.styles';

function RichText(props) {
  const { content, converters, whitelist, allowedObjects, disabled, labelColor } = props;
  const mergedConverters = {
    ...defaultConverters,
    ...converters
  };

  // Sanitize and parse content
  const sanitizedContent = DOMPurify.sanitize(content, {
    FORBID_TAGS: ['script'], // Prevents script injection
    ALLOWED_TAGS: Object.keys(mergedConverters) // Only allow tags that have converters
  });

  return (
    <StyledRichText labelColor={labelColor} disabled={disabled}>
      {parse(sanitizedContent, {
        replace: (node) => transform(node, { allowedObjects, convert: mergedConverters, whitelist })
      })}
    </StyledRichText>
  );
}

RichText.propTypes = {
  content: PropTypes.string,
  converters: PropTypes.object, // eslint-disable-line
  whitelist: PropTypes.arrayOf(PropTypes.string),
  allowedObjects: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  labelColor: PropTypes.string
};

RichText.defaultProps = {
  content: '',
  whitelist: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'strong', 'br', 'a', 'ul', 'li', 'table', 'tbody', 'tr', 'td'],
  allowedObjects: [],
  converters: {},
  disabled: false,
  labelColor: ''
};

export default RichText;
